import React, { useState, useEffect, useCallback } from "react";
import {
  AppBar,
  Toolbar,
  Container,
  Stepper,
  Step,
  StepLabel,
  Button,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  IconButton,
  Modal,
  Box,
  Typography,
  Slider,
  CircularProgress,
  Paper,
  Grid,
} from "@mui/material";
import { Row, Col, Form, InputGroup, OverlayTrigger } from "react-bootstrap";
// import { CheckCircle, Info, Visibility, VisibilityOff, Refresh, Close, Check } from '@mui/icons-material';
// import logo from '../../assets/img/logo-white-paybito.png';
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import InfoIcon from "@mui/icons-material/Info";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import RefreshIcon from "@mui/icons-material/Refresh";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";
import { showToast, WEBSERVICE } from "../../CoreDataService";
import CaptchaModal from "../Login/CaptchaModal";
import axios from "axios";
import { useForm } from "react-hook-form";
import {
  isMobile,
  isTablet,
  isDesktop,
  browserName,
  browserVersion,
} from "react-device-detect";
import Fingerprint2 from "fingerprintjs2";
import Cookies from "js-cookie";
import { useLocation, useNavigate } from "react-router-dom";
import ModalContent from "../../Common/Modal";
import { useSelector } from "react-redux";

const SocialSignupPage = () => {
  const navigate = useNavigate();
  const { btncolor } = useSelector((state) => state);
  const themeColor = localStorage.getItem("theme");

  const [step, setStep] = useState(1);
  const [gender, setGender] = useState("Male");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [brokerId, setBrokerId] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [referralCode, setReferralCode] = useState("");
  const [captchaSuccess, setCaptchaSuccess] = useState(false);
  const [sliderValue, setSliderValue] = useState(0);
  const [loadingImage, setLoadingImage] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [openBrokerModal, setOpenBrokerModal] = useState(false);
  const [openCountryModal, setOpenCountryModal] = useState(false);
  const [openCaptchaModal, setOpenCaptchaModal] = useState(false);
  const [showCaptchaModal, setShowCaptchModal] = useState(false);
  const handlecloseCaptcha = () => setShowCaptchModal(false);

  // Form validation states
  const [nameError, setNameError] = useState("");
  const NAME_REGEX = /^[A-Za-z]+(?:[ '’-][A-Za-z]+)*$/;
  const [emailError, setEmailError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [brokerIdError, setBrokerIdError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");

  const [showPhoneDisclaimer, setShowPhoneDisclaimer] = useState(false);
  const [show, setShow] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredCountries, setFilterCountry] = useState([]);
  const [countryFlag, setCountryFlag] = useState([]);
  const [exchangeUnderOpecCountry, setExchangeUnderOpecCountry] = useState(0);
  const [deviceDetails, setDeviceDetails] = useState(null);
  const [referredByUser, setReferredByUser] = useState("");
  const [referrerTypeUser, setReferrerTypeUser] = useState("");
  const [userCountryCode, setUserCountryCode] = useState("");
  const [userPhone, setUserPhone] = useState("");

  const {
    register,
    formState: { errors },
    trigger,
    watch,
    setValue,
    setError,
    clearErrors,
    getValues,
  } = useForm();

  const steps = ["Account Details", "Password", "Referral Code"];

  useEffect(() => {
    handleFilterCountry();
  }, [searchTerm]);

  useEffect(() => {
    if (email) {
      checkEmail();
    }
  }, [email]);

  const checkEmail = async () => {
    if (email && email.trim() !== "") {
      try {
        const emailObj = { email: email };
        const response = await axios.post(
          `${WEBSERVICE}user/CheckEmail`,
          emailObj,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        const result = response.data;

        if (result.error.error_data !== 0) {
          showToast(result.error.error_msg); // You can replace this with a toast/snackbar
        } else {
          if (result.userResult.checkEmailPhoneFlag === 1) {
            showToast(
              "error",
              "Email already registered, please try with another email address"
            );
            setEmail("");
          } else {
            // Email is valid and not registered
            // Perform further actions here
          }
        }
      } catch (error) {
        console.error(error);
        showToast("error", "Internal Server Error");
      }
    } else {
      showToast("error", "Please Provide Email Id");
    }
  };

  useEffect(() => {
    if (localStorage.getItem("socialLoginType") == "facebook") {
      if (localStorage.getItem("facebook_email") != "undefined") {
        setEmail(localStorage.getItem("facebook_email"));
      } else {
        setEmail("");
      }

      if (localStorage.getItem("facebook_name") != "undefined") {
        setName(localStorage.getItem("facebook_name"));
      } else {
        setName("");
      }
    } else if (localStorage.getItem("socialLoginType") == "google") {
      if (localStorage.getItem("google_email") != "undefined") {
        setEmail(localStorage.getItem("google_email"));
      } else {
        setEmail("");
      }

      if (localStorage.getItem("google_name") != "undefined") {
        setName(localStorage.getItem("google_name"));
      } else {
        setName("");
      }
    }
    if (localStorage.getItem("socialLoginType") == "linkedin") {
      if (localStorage.getItem("linkedin_email") != "undefined") {
        setEmail(localStorage.getItem("linkedin_email"));
      } else {
        setEmail("");
      }

      if (localStorage.getItem("linkedin_name") != "undefined") {
        setName(localStorage.getItem("linkedin_name"));
      } else {
        setName("");
      }
    }
  }, []);

  useEffect(() => {
    // console.log('brokerBasicInfo', brokerBasicInfo);

    getCountryFlag();
    getDeviceDetails();
  }, [exchangeUnderOpecCountry]);

  const getDeviceDetails = async () => {
    const response = await axios.get(
      "https://api.ipgeolocation.io/ipgeo?apiKey=693da481af1b4a3e80e3dfea9115dc52"
    );
    setDeviceDetails(response.data);
  };

  const handleFilterCountry = useCallback(() => {
    if (searchTerm !== "") {
      const filteredData = countryFlag.filter(
        (country) =>
          country.country.toLowerCase().includes(searchTerm.toLowerCase()) ||
          country.value.toString().includes(searchTerm)
      );
      setFilterCountry(filteredData);
    } else {
      setFilterCountry(countryFlag);
    }
  }, [searchTerm]);

  useEffect(() => {
    // console.log('brokerBasicInfo', brokerBasicInfo);

    getCountryFlag();
  }, []);

  const checkCountryIsopec = async (country) => {
    try {
      const res = await axios.get(
        `https://accounts.paybito.com/api/home/ofacCheck/${country}`
      );
      const data = res.data;
      setExchangeUnderOpecCountry(data.isOfac);
    } catch (error) {
      console.error("Error in checkCountryIsopec:", error);
    }
  };

  const getCountryFlag = async () => {
    const response = await axios.get(
      `https://accounts.paybito.com/api/home/getExchangeCountries/${localStorage.getItem(
        "BROKERID"
      )}`
    );

    const sortCountry = response?.data?.countries
      ?.sort((a, b) =>
        a.country.toLowerCase().localeCompare(b.country.toLowerCase())
      )
      ?.map((country) => ({
        value: country.dialCode,
        country: country.country,
        label: `(+${country.dialCode}) ${country.country}`,
        flag: `https://flagcdn.com/w40/${country.code.toLowerCase()}.png`,
      }));

    if (exchangeUnderOpecCountry === 1) {
      const filterData = sortCountry?.filter(
        (d) => d?.value === "98" || d?.value === "7"
      );
      setCountryFlag(filterData);
      setFilterCountry(filterData);
      setSelectedCountry(filterData[0]);
    } else {
      setCountryFlag(sortCountry);
      setFilterCountry(sortCountry);
      const selectedCountryCode = sortCountry?.filter(
        (d) => d?.country === "United States"
      );
      setSelectedCountry(selectedCountryCode[0]);
    }
  };

  const validatePhoneNumber = async (phone) => {
    if (selectedCountry) {
      if (phone) {
        const data = {
          countryCode: selectedCountry?.value,
          phone: phone,
        };
        const response = await axios.post(`${WEBSERVICE}user/CheckPhone`, data);
        if (response?.data?.error?.error_data === 1) {
          showToast("error", response?.data?.error?.error_msg);
        } else {
          if (response?.data?.userResult.checkEmailPhoneFlag === 1) {
            showToast(
              "error",
              "Phone No. already registered , please try with another phone no."
            );
          }
        }
      } else {
        showToast("warning", "Please Provide Phone No");
      }
    } else {
      showToast("error", "Please select phone country code");
    }
  };

  const handleNameKeyDown = (e) => {
    const key = e.key;
    if (
      key === "Backspace" ||
      key === "Tab" ||
      key === "ArrowLeft" ||
      key === "ArrowRight" ||
      key === "Delete"
    ) {
      return;
    }
    if (!/^[a-zA-Z\s'’-]$/.test(key)) {
      e.preventDefault();
      return;
    }
    if (e.target.value.length >= 100) {
      e.preventDefault();
      setNameError("Maximum length: 100 characters");
    }
  };

  const handleNamePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("Text");
    const filtered = pastedData.replace(/[^A-Za-z\s'’-]/g, "").slice(0, 100);
    const target = e.target;
    const newValue =
      target.value.slice(0, target.selectionStart) +
      filtered +
      target.value.slice(target.selectionEnd);
    setName(newValue);
    setNameError(
      newValue && !NAME_REGEX.test(newValue)
        ? "Allowed characters: Alphabets, Spaces, Hyphen (-), Apostrophe (')"
        : ""
    );
  };

  const handleNameChange = (e) => {
    const value = e.target.value;
    setName(value);
    if (!value) {
      setNameError("Name is required");
    } else if (!NAME_REGEX.test(value)) {
      setNameError(
        "Allowed characters: Alphabets, Spaces, Hyphen (-), Apostrophe (')"
      );
    } else {
      setNameError("");
    }
  };

  const handleNext = () => {
    // Get full phone number
    const fullPhoneNumber = `+${
      selectedCountry?.value || countryFlag[0]?.value
    }${phone}`;

    console.log("Validation check:", {
      step,
      name,
      email,
      phone,
      selectedCountry: selectedCountry?.value,
      fullPhoneNumber,
      password,
      confirmPassword,
      referralCode,
    });

    if (step === 1) {
      setUserCountryCode(selectedCountry?.value);
      setUserPhone(phone);
    }

    // Validate current step before proceeding
    const isNameInvalid = !name || !NAME_REGEX.test(name);

    if (step === 1 && (isNameInvalid || !email || !phone)) {
      if (!name) {
        setNameError("Name is required");
      } else if (!NAME_REGEX.test(name)) {
        setNameError(
          "Allowed characters: Alphabets, Spaces, Hyphen (-), Apostrophe (')"
        );
      }
      if (!email) setEmailError("Email is required");
      if (!phone) {
        console.log("Phone is required");
        // setPhoneError('Phone is required');
      }
      return;
    }

    if (step === 2) {
      const passwordRegex =
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@#.!\-])[A-Za-z\d$@#.!\-]{8,35}$/;

      let isValid = true;

      if (!password) {
        setPasswordError("Password is required");
        isValid = false;
      } else if (!passwordRegex.test(password)) {
        setPasswordError(
          "Password must be 8-35 characters, include uppercase, lowercase, number, and special character ($@#.!-)"
        );
        isValid = false;
      } else {
        setPasswordError("");
      }

      if (!confirmPassword) {
        setConfirmPasswordError("Please confirm password");
        isValid = false;
      } else if (password !== confirmPassword) {
        setConfirmPasswordError("Passwords do not match");
        isValid = false;
      } else {
        setConfirmPasswordError("");
      }

      if (!isValid) return;
    }

    if (step === 3) {
      // Referral Code check
      if (referralCode.trim() !== "") {
        // setInvalid(true); // optimistic UI, assume invalid initially
        const referralCodeObj = { referralCode: referralCode.trim() };

        axios
          .post(`${WEBSERVICE}user/checkReferralCode`, referralCodeObj, {
            headers: {
              "Content-Type": "application/json",
            },
          })
          .then((response) => {
            const result = response.data;
            if (result.error.error_data !== 0) {
              setStep(4); // proceed to next step even if referral code invalid
              // setReferralCode(''); // clear input
              showToast("error", result.error.error_msg);
              // setInvalid(true);
            } else {
              showToast("success", "Valid Referral Code");
              setReferredByUser(referralCode.trim());
              setReferrerTypeUser(result.userResult.referrerType);
              // setInvalid(false);
              setStep(4); // move to next step if referral code valid
            }
          })
          .catch((error) => {
            showToast("error", "Internal Server Error");
          });
      } else {
        // Referral code is optional, move to next step
        setStep(4);
      }
      return; // prevent further execution until API call finishes
    }

    console.log("Moving to step:", step + 1);
    setStep(step + 1);
  };

  const handleBack = () => {
    setStep(step - 1);
  };

  const handleSubmit = () => {
    if (!captchaSuccess) {
      setOpenCaptchaModal(true);
      return;
    }
    // Submit form logic
    console.log("Form submitted");
  };

  const handlePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleBrokerInfo = () => {
    setOpenBrokerModal(true);
  };

  const copyBrokerId = () => {
    navigator.clipboard.writeText("PAYB18022021121103");
    setOpenBrokerModal(false);
  };

  const handleSliderChange = (event, newValue) => {
    setSliderValue(newValue);
    // Add your puzzle piece movement logic here
  };

  const regenerateCaptcha = () => {
    setLoadingImage(true);
    // Simulate loading
    setTimeout(() => {
      setLoadingImage(false);
      setSliderValue(0);
    }, 1000);
  };

  const verifyCaptcha = () => {
    if (sliderValue > 90) {
      // Assuming 90% is success threshold
      setSuccessMessage("Verification successful!");
      setErrorMessage("");
      setCaptchaSuccess(true);
      setTimeout(() => {
        setOpenCaptchaModal(false);
      }, 1000);
    } else {
      setErrorMessage("Verification failed. Please try again.");
      setSuccessMessage("");
    }
  };

  const handleBrokerIdCheck = async (e) => {
    const value = e.target.value;
    console.log("Broker ID Check Value:", value);

    if (value !== "") {
      const payload = {
        brokerId: value,
      };

      try {
        const response = await fetch(`${WEBSERVICE}user/CheckBroker`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });

        const result = await response.json();

        if (result.error.error_data !== 0) {
          e.target.value = "";
          setBrokerId("");
          setStep(2);
          // Assuming you have some alert system in React
          showToast("error", result.error.error_msg); // Or use your preferred notification system
        }
      } catch (error) {
        console.error("Error:", error);
        alert("Internal Server Error"); // Or use your preferred notification system
      }
    }
  };

  const SubmitCaptcha = async (captcha, sessionId) => {
    const payload = {
      country: selectedCountry?.country,
      latitude: deviceDetails?.latitude,
      longitude: deviceDetails?.longitude,
      ipAddress: deviceDetails?.ip,
      location: deviceDetails?.country_name,
      brokerId: "PAYB18022021121103",
      email: email,
      password: password,
      firstName: name,
      lastName: name,
      gender: gender,
      phone: userPhone,
      repassword1: password,
      countryCode: userCountryCode,

      deviceId: Cookies.get("deviceID"),
      deviceType: isMobile
        ? "mobile"
        : isTablet
        ? "tablet"
        : isDesktop
        ? "Desktop browser"
        : "unknown",
      browser: `${browserName} ${browserVersion}`,
      gRecaptchaResponse: captcha,
      sessionId: sessionId,
      referralCode: referralCode,
      referredBy: referredByUser,
      referrerType: referrerTypeUser,
    };

    let names = name.split(" ");
    if (name.length == "3") {
      payload["firstName"] = names[0];
      payload["middleName"] = names[1];
      payload["lastName"] = names[2];
    } else {
      payload["firstName"] = names[0];
      payload["lastName"] = names[1];
      payload["middleName"] = "";
    }
    payload["loginType"] = 2;
    if (localStorage.getItem("socialLoginType") == "facebook") {
      payload["socialMediaId"] = localStorage.getItem("facebook_app_id");
    } else if (localStorage.getItem("socialLoginType") == "google") {
      payload["socialMediaId"] = localStorage.getItem("google_app_id");
    } else if (localStorage.getItem("socialLoginType") == "linkedin") {
      payload["socialMediaId"] = localStorage.getItem("linkedin_app_id");
    }

    try {
      const response = await axios.post(
        `${WEBSERVICE}user/AddUserDetails`,
        payload
      );
      if (response?.data?.error?.error_data === 0) {
        showToast(
          "success",
          "Please check your email for the verification token to complete the registration."
        );
        localStorage.setItem("emailForUser", email);
        localStorage.setItem("userId", response?.data?.userResult?.userId);
        navigate("/otp");
      } else {
        showToast("error", response?.data?.error?.error_msg);
      }
    } catch (e) {
      showToast("error", e?.response?.data?.error?.error_msg);
    }
  };

  return (
    <div className="pageBackground">
      {/* <AppBar position="fixed" sx={{ backgroundColor: '#102ab3' }}>
                <Toolbar>
                    <img src="https://trade.paybito.com/assets/img/logo-white-paybito.png" alt="Paybito" style={{ height: 40 }} />
                </Toolbar>
            </AppBar> */}

      <Container maxWidth="md" sx={{ pt: 12, pb: 4 }}>
        <Paper
          elevation={3}
          sx={{
            p: 4,
            mb: 4,
            background: "#ffffff", // White background
            color: "#000000", // Black text
            "& .MuiStepLabel-label": {
              color: "#000000", // Ensure step labels are black
            },
          }}
        >
          <Stepper activeStep={step - 1} alternativeLabel>
            {steps.map((label, index) => (
              <Step key={label}>
                <StepLabel
                  icon={
                    step > index + 1 ? (
                      <CheckCircleIcon style={{ color: "#000000" }} />
                    ) : (
                      <span style={{ color: "#000000" }}>{index + 1}</span>
                    )
                  }
                >
                  <span style={{ color: "#000000" }}>{label}</span>
                </StepLabel>
              </Step>
            ))}
          </Stepper>
        </Paper>

        <Paper
          elevation={3}
          sx={{
            p: 4,
            backgroundColor: "#ffffff", // White background
            color: "#000000", // Black text
          }}
        >
          <form>
            {step === 1 && (
              <>
                <div
                  style={{ display: "flex", gap: "16px", marginBottom: "16px" }}
                >
                  <FormControl fullWidth>
                    <InputLabel
                      sx={{ color: (theme) => theme.palette.text.primary }}
                    >
                      Title
                    </InputLabel>
                    <Select
                      value={gender}
                      onChange={(e) => setGender(e.target.value)}
                      label="Title"
                      sx={{
                        color: "#000000",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "rgba(0, 0, 0, 0.23)", // Standard border color
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#000000", // Darker on hover
                        },
                      }}
                    >
                      <MenuItem value="Male">Mr.</MenuItem>
                      <MenuItem value="Female">Ms.</MenuItem>
                      <MenuItem value="Other">Other</MenuItem>
                    </Select>
                  </FormControl>
                  <TextField
                    fullWidth
                    label="Name"
                    value={name}
                    onChange={handleNameChange}
                    onKeyDown={handleNameKeyDown}
                    onPaste={handleNamePaste}
                    onBlur={(e) => {
                      const trimmed = e.target.value.trim();
                      setName(trimmed);
                      setNameError(
                        trimmed && !NAME_REGEX.test(trimmed)
                          ? "Allowed characters: Alphabets, Spaces, Hyphen (-), Apostrophe (')"
                          : trimmed
                          ? ""
                          : "Name is required"
                      );
                    }}
                    error={!!nameError}
                    helperText={nameError}
                    required
                    InputLabelProps={{
                      style: { color: "#000000" },
                    }}
                    sx={{
                      mb: 2,
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: "rgba(0, 0, 0, 0.23)",
                        },
                        "&:hover fieldset": {
                          borderColor: "#000000",
                        },
                      },
                      "& .MuiInputBase-input": {
                        color: "#000000",
                      },
                    }}
                  />
                </div>
                <TextField
                  className="socialEmailInput"
                  fullWidth
                  label="Email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  error={!!emailError}
                  helperText={emailError}
                  required
                  autoComplete="email"
                  InputLabelProps={{
                    style: { color: "#000000" },
                  }}
                  sx={{
                    mb: 2,
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "rgba(0, 0, 0, 0.23)",
                      },
                      "&:hover fieldset": {
                        borderColor: "#000000",
                      },
                      "& input": {
                        color: "#000000",
                      },
                      "& input:-webkit-autofill": {
                        WebkitBoxShadow: "0 0 0px 1000px white inset", // background color
                        WebkitTextFillColor: "#000000", // text color
                      },
                    },
                    "& .MuiInputBase-input": {
                      color: "#000000",
                    },
                  }}
                />

                <Grid item xs={12}>
                  <Form.Group controlId="phone" className="mt-1">
                    <InputGroup>
                      <div style={{ position: "relative" }}>
                        <div
                          onClick={() => setIsOpen(!isOpen)}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            padding: "10px",
                            border: "1px solid #ccc",
                            borderRadius: "5px",
                            cursor: "pointer",
                            minWidth: "80px",
                          }}
                        >
                          <img
                            src={selectedCountry?.flag || countryFlag[0]?.flag}
                            alt={selectedCountry?.code || countryFlag[0]?.code}
                            style={{
                              width: "20px",
                              height: "15px",
                              marginRight: "5px",
                            }}
                          />
                          <span style={{ fontSize: "12px" }}>
                            +{selectedCountry?.value || countryFlag[0]?.value}
                          </span>
                        </div>

                        {/* Dropdown menu */}
                        {isOpen && (
                          <div
                            style={{
                              position: "absolute",
                              top: "100%",
                              left: 0,
                              width: "360px",
                              border: "1px solid #ccc",
                              borderRadius: "5px",
                              background: "#fff",
                              zIndex: 1000,
                              maxHeight: "200px",
                              overflowY: "auto",
                            }}
                          >
                            {/* Search bar */}
                            <input
                              type="text"
                              placeholder="Search country"
                              value={searchTerm}
                              onChange={(e) => setSearchTerm(e.target.value)}
                              style={{
                                width: "100%",
                                padding: "10px",
                                border: "none",
                                borderBottom: "1px solid #ccc",
                                outline: "none",
                              }}
                            />
                            {/* Country list */}
                            {filteredCountries &&
                            filteredCountries.length !== 0 ? (
                              filteredCountries.map((country) => (
                                <div
                                  key={country.value} // Fixed: Added key prop
                                  onClick={() => {
                                    setSelectedCountry(country);
                                    setIsOpen(false);
                                    console.log("Selected country:", country); // Debug
                                  }}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    padding: "10px",
                                    cursor: "pointer",
                                    background:
                                      selectedCountry?.value === country?.value
                                        ? "#f0f0f0"
                                        : "#fff",
                                  }}
                                >
                                  <img
                                    src={country?.flag}
                                    alt={country?.code}
                                    style={{ width: "20px", height: "15px" }}
                                  />
                                  &nbsp;
                                  <span style={{ color: "#555" }}>
                                    {`+(${country?.value})`}
                                  </span>
                                  <span
                                    style={{
                                      marginLeft: "10px",
                                      color: "#555",
                                    }}
                                  >
                                    {country?.country}
                                  </span>
                                </div>
                              ))
                            ) : (
                              <div style={{ padding: "10px", color: "#888" }}>
                                No results found
                              </div>
                            )}
                          </div>
                        )}
                      </div>

                      <Form.Control
                        type="tel" // Changed from "number" to "tel"
                        placeholder="Phone number *"
                        className="black-autofill"
                        value={phone} // Added value prop
                        onChange={(e) => {
                          setPhone(e.target.value);
                          console.log("Phone changed:", e.target.value); // Debug
                        }}
                        // Removed react-hook-form register
                        onKeyDown={(e) => {
                          if (e.ctrlKey || e.metaKey) {
                            return;
                          }

                          if (
                            !/^\d$/.test(e.key) &&
                            ![
                              "Backspace",
                              "Delete",
                              "ArrowLeft",
                              "ArrowRight",
                              "Tab",
                            ].includes(e.key)
                          ) {
                            e.preventDefault();
                          }
                        }}
                        inputMode="numeric"
                        onPaste={(e) => {
                          const pastedData = e.clipboardData.getData("Text");
                          if (!/^\d+$/.test(pastedData)) {
                            e.preventDefault();
                          }
                        }}
                        onFocus={() => setShowPhoneDisclaimer(true)}
                        onBlur={(e) => {
                          validatePhoneNumber(e.target.value);
                          setShowPhoneDisclaimer(false);
                          // Removed trigger("phone")
                        }}
                      />
                    </InputGroup>

                    {showPhoneDisclaimer && (
                      <span style={{ color: "gray", fontSize: "11px" }}>
                        Messages and data rates may apply. If you choose to
                        receive MFA passwords as text messages, We will send you
                        one text message per login attempt. To stop receiving
                        messages, reply STOP to the message. Alternatively, you
                        can go to the Settings menu, once you login and
                        deactivate phone authentication. Please review the Terms
                        of use and Privacy policy on this page.
                      </span>
                    )}

                    {/* Add phone error display if you have phoneError state */}
                    {/* {phoneError && (
            <p className="text-danger">{phoneError}</p>
        )} */}
                  </Form.Group>
                </Grid>
              </>
            )}

            {step === 2 && (
              <>
                <TextField
                  fullWidth
                  label="Password"
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  error={!!passwordError}
                  helperText={
                    passwordError ||
                    "Minimum 8 characters with uppercase, lowercase, number and special character"
                  }
                  required
                  InputProps={{
                    style: { color: "#000000" },
                    endAdornment: (
                      <IconButton onClick={handlePasswordVisibility}>
                        {showPassword ? (
                          <VisibilityOffIcon color="action" />
                        ) : (
                          <VisibilityIcon color="action" />
                        )}
                      </IconButton>
                    ),
                  }}
                  InputLabelProps={{
                    style: { color: "#000000" },
                  }}
                  sx={{
                    mb: 2,
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "rgba(0, 0, 0, 0.23)",
                      },
                      "&:hover fieldset": {
                        borderColor: "#000000",
                      },
                    },
                    "& .MuiInputBase-input": {
                      color: "#000000",
                    },
                  }}
                />
                <TextField
                  fullWidth
                  label="Confirm Password"
                  type={showPassword ? "text" : "password"}
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  error={!!confirmPasswordError}
                  helperText={confirmPasswordError}
                  required
                  InputLabelProps={{
                    style: { color: "#000000" },
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "rgba(0, 0, 0, 0.23)",
                      },
                      "&:hover fieldset": {
                        borderColor: "#000000",
                      },
                    },
                    "& .MuiInputBase-input": {
                      color: "#000000",
                    },
                  }}
                />
              </>
            )}

            {step === 3 && (
              <TextField
                fullWidth
                label="Referral Code (Optional)"
                value={referralCode}
                onChange={(e) => setReferralCode(e.target.value)}
                InputLabelProps={{
                  style: { color: "#000000" },
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: "rgba(0, 0, 0, 0.23)",
                    },
                    "&:hover fieldset": {
                      borderColor: "#000000",
                    },
                  },
                  "& .MuiInputBase-input": {
                    color: "#000000",
                  },
                }}
              />
            )}

            {step === 4 && (
              <div style={{ textAlign: "center", margin: "20px 0" }}>
                <Button
                  className="primaryButton"
                  variant={captchaSuccess ? "contained" : "outlined"}
                  color={captchaSuccess ? "success" : "primary"}
                  startIcon={captchaSuccess ? <CheckIcon /> : null}
                  onClick={() => setShowCaptchModal(true)}
                >
                  {captchaSuccess ? "Verified" : "Verify Captcha"}
                </Button>
              </div>
            )}

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "16px",
                marginTop: "24px",
              }}
            >
              {step > 1 && (
                <Button
                  variant="outlined"
                  sx={{
                    borderColor: btncolor,
                    color: themeColor === "dark" ? "#fff" : btncolor,
                  }}
                  onClick={handleBack}
                >
                  Back
                </Button>
              )}
              {step < 4 ? (
                <Button
                  variant="contained"
                  className="primaryButton"
                  onClick={handleNext}
                >
                  Next
                </Button>
              ) : (
                ""
              )}

              <CaptchaModal
                setState={setShowCaptchModal}
                showCaptchaModal={showCaptchaModal}
                handleCaptchaSubmit={SubmitCaptcha}
              />
            </div>
          </form>
        </Paper>
      </Container>

      {/* Broker Info Modal */}
      <ModalContent
        open={openBrokerModal}
        onClose={() => setOpenBrokerModal(false)}
      >
        <Typography variant="h6" gutterBottom>
          Broker ID Information
        </Typography>
        <Typography paragraph>
          PayBitoPro Broker / Membership ID is PAYB18022021121103.
        </Typography>
        <Typography paragraph>
          Please use this or the one provided by your Broker.
        </Typography>
        <div
          style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}
        >
          <Button onClick={copyBrokerId}>Copy</Button>
          <Button variant="contained" onClick={() => setOpenBrokerModal(false)}>
            Close
          </Button>
        </div>
      </ModalContent>

      {/* Captcha Modal */}
      <ModalContent
        open={openBrokerModal}
        onClose={() => setOpenBrokerModal(false)}
        title={"Verify"}
      >
        {loadingImage ? (
          <CircularProgress />
        ) : (
          <>
            <Typography variant="body1" gutterBottom>
              Slide to complete the puzzle
            </Typography>

            <Box sx={{ position: "relative", height: 150, mb: 2 }}>
              {/* Base image */}
              <Box
                component="img"
                src="/path-to-base-image.jpg" // Replace with your image path
                alt="Base"
                sx={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
              {/* Puzzle piece */}
              <Box
                component="img"
                src="/path-to-puzzle-piece.jpg" // Replace with your image path
                alt="Puzzle Piece"
                sx={{
                  position: "absolute",
                  top: 50,
                  left: sliderValue * 3, // Adjust multiplier based on your needs
                  width: 50,
                  height: 50,
                }}
              />
            </Box>

            <Slider
              value={sliderValue}
              onChange={handleSliderChange}
              onChangeCommitted={verifyCaptcha}
              sx={{ width: "80%", mx: "auto", mb: 2 }}
            />

            <div
              style={{ display: "flex", justifyContent: "center", gap: "16px" }}
            >
              <IconButton onClick={regenerateCaptcha}>
                <RefreshIcon />
              </IconButton>
            </div>

            {successMessage && (
              <Typography color="success.main">{successMessage}</Typography>
            )}
            {errorMessage && (
              <Typography color="error.main">{errorMessage}</Typography>
            )}
          </>
        )}
      </ModalContent>

      <style jsx>
        {`
          .pageBackground {
            background: linear-gradient(
              90deg,
              rgb(227, 24, 54) 0%,
              rgb(16, 42, 179) 60%
            );
            height: 100%;
          }
        `}
      </style>
    </div>
  );
};

export default SocialSignupPage;
